module.exports = __webpack_public_path__ + "img/construction_271487904_2_25f.1ac70dfd.jpeg";